import Vue from 'vue';
import PopupFullscreen from '../../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../../core/animation/fade/animation-fade';

export default function () {
  const galleryPlate = document.querySelectorAll('.gallery-plate');

  if (galleryPlate.length) {
    [].slice.call(galleryPlate).forEach((elem) => {
      const objectName = elem.getAttribute('data-object');
      const object = window[`${objectName}`];

      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          PopupFullscreen,
        },
        data() {
          return {
            galleryPlate: object,
            galleryPlateHtml: object.images ? object.images.slice(0, 4) : [],
            newTitle: '',
            isMobile: window.innerWidth < 1280,
            mainSlider: null,
            thumbSlider: null,
            thumb: null,
            main: null,
            optionsMain: null,
            optionsThumb: null,
            activeTabs: null,
            popupFullOpen: false,
            tabs: null,
            facing: null,
            tabArrows: [],
            sliders: [],
            fullscreenCards: [],
            fullscreenActive: 0,
            description: '',
            currentIndex: 0,
            activeTabButton: null,
          };
        },
        mounted() {
          this.fullscreenCards = [];

          if (this.galleryPlate.images) {
            this.galleryPlate.images.forEach((slide) => {
              this.fullscreenCards.push(slide);
            });
          }
        },
        methods: {
          openFullPopup(event) {
            const plate = event.target.closest('.gallery-plate__plate');
            this.fullscreenActive = plate ? Number(plate.getAttribute('data-index')) : 0;
            const popup = this.$el.querySelector('.popup-fullscreen');
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
        },
        computed: {
          wrapperClass() {
            const isMoreThenFour = object.images && object.images.length <= 4 ? 'gallery-plate__plates-wrp--hidden-images' : '';
            return `gallery-plate__plates-wrp--count-${object.images.length > 4 ? 4 : object.images.length} ${isMoreThenFour}`;
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/gallery/plate/gallery-plate.js